<template>
  <div class="call-center-settings-page">
    <v-tabs
      v-model="activeTab"
      background-color="transparent"
      class="call-center-settings-tabs mb-4"
      slider-color="primary"
    >
      <v-tab class="call-center-settings-tab">أسماء موظفي الكول سنتر</v-tab>
      <v-tab class="call-center-settings-tab">الاكواد الخاصه بالمكالمات الوارده والصادره من الكول سنتر</v-tab>
    </v-tabs>

    <v-tabs-items v-model="activeTab" class="call-center-settings-tabs-items">
      <v-tab-item>
        <v-card class="call-center-settings-card">
          <v-card-title class="call-center-settings-title">أسماء موظفي الكول سنتر</v-card-title>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12" class="py-0">
                <div class="selectInput call-center-tags-field">
                  <v-container>
                    <v-combobox
                      v-model="tags"
                      label="أضافة أسماء الكول سنتر "
                      multiple
                      chips
                      clearable
                      outlined
                      dense
                      class="call-center-combobox"
                      @keydown.tab="addTag"
                      @keydown.enter="addTag"
                    >
                      <template v-slot:selection="{ attrs, item, select, selected }">
                        <v-chip
                          v-bind="attrs"
                          class="call-center-tag-chip"
                          :input-value="selected"
                          close
                          small
                          @click="select"
                          @click:close="removeTag(item)"
                        >
                          {{ item }}
                        </v-chip>
                      </template>
                    </v-combobox>
                  </v-container>
                </div>
              </v-col>
            </v-row>
          </v-container>

          <v-card-actions class="call-center-settings-actions">
            <v-spacer></v-spacer>
            <v-btn color="primary" class="call-center-save-btn" @click="updateSetting">
              حفظ
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <CallCenterQueuesSetting />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<style lang="scss" scoped>
.call-center-settings-page {
  padding: 4px 0 16px;
}

.call-center-settings-tabs ::v-deep .call-center-settings-tab {
  font-weight: 600;
  letter-spacing: 0;
  color: #5f5f5f !important;
  opacity: 1 !important;
}

.call-center-settings-tabs ::v-deep .call-center-settings-tab.v-tab--active {
  color: #3f0e40 !important;
}

.call-center-settings-tabs ::v-deep .v-tabs-slider {
  background-color: #7e1280 !important;
}

.call-center-settings-card {
  padding: 10px 12px 8px;
  border: 1px solid rgba(63, 14, 64, 0.12);
  border-radius: 12px;
  background: #ffffff;
}

.call-center-settings-title {
  color: #3f0e40;
  font-weight: 700;
  font-size: 1.15rem;
}

.call-center-settings-actions {
  padding: 8px 16px 16px;
}

.call-center-save-btn {
  min-width: 110px;
  font-weight: 600;
}

.call-center-tag-chip {
  background: rgba(126, 18, 128, 0.12) !important;
  color: #5a125c !important;
}

.call-center-combobox ::v-deep .v-label {
  color: #666;
}

.dark .call-center-settings-tabs ::v-deep .v-tabs-slider {
  background-color: #ce93d8 !important;
}

.dark .call-center-settings-card {
  background: #1e1e1e;
  border-color: rgba(255, 255, 255, 0.12);
}

.dark .call-center-settings-title {
  color: rgba(255, 255, 255, 0.92);
}

.dark .call-center-tag-chip {
  background: rgba(171, 71, 188, 0.22) !important;
  color: #e1bee7 !important;
}

.dark .call-center-combobox ::v-deep .v-label,
.dark .call-center-combobox ::v-deep input {
  color: rgba(255, 255, 255, 0.88);
}

.dark .call-center-combobox ::v-deep .v-input__slot {
  border-color: rgba(255, 255, 255, 0.24) !important;
}
</style>

<style lang="scss">
.call-center-settings-page .call-center-settings-tab {
  color: #5f5f5f !important;
  opacity: 1 !important;
}

.call-center-settings-page .call-center-settings-tab.v-tab--active {
  color: #3f0e40 !important;
}

.dark .call-center-settings-page .call-center-settings-tab,
.v-application.dark .call-center-settings-page .call-center-settings-tab {
  color: rgba(255, 255, 255, 0.72) !important;
}

.dark .call-center-settings-page .call-center-settings-tab.v-tab--active,
.v-application.dark .call-center-settings-page .call-center-settings-tab.v-tab--active {
  color: #e1bee7 !important;
}

.call-center-settings-page {
  .loadingMore {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 40px;
  }

  .text__success {
    color: green;
  }

  .text__faild {
    color: red;
  }

  th.text-start.sortable {
    text-align: center !important;
  }

  .v-text-field {
    padding-top: 12px !important;
    margin-top: 4px;
  }

  label.v-label.v-label--active.theme--light.primary--text,
  .dark label.v-label.v-label--active.primary--text {
    left: auto;
    position: absolute;
    top: 0;
    right: -11px;
  }
}
</style>

<script>
import Axios from "axios";
import { axiosInstance } from "@/axios/config";
import CallCenterQueuesSetting from "./CallCenterQueuesSetting.vue";

export default {
  name: "CustomersSettingIndex",
  components: {
    CallCenterQueuesSetting,
  },
  data() {
    return {
      activeTab: 0,
      page: 1,
      loading: false,
      copySupportRequests: [],
      loadMoreData: false,
      loadingData: false,
      iconToggle: false,
      newTag: '',
      tags: [],
    };
  },

  methods: {
    addTag(event) {
      event.preventDefault();
      const inputValue = event.target?.value?.trim();
      if (inputValue && !this.tags.includes(inputValue)) {
        this.tags.push(inputValue);
      }
    },
    removeTag(tag) {
      this.tags = this.tags.filter((t) => t !== tag);
    },
    getSettingData() {
      Axios.get(`${this.$store.state.url}/employee/admin/call-center-names`, {
        headers: this.request_headers(),
      }).then((res) => {
        this.tags = res.data.payload || [];
        this.loading = false;
      });
    },
    updateSetting() {
      const body = new FormData();
      body.append("users", this.tags);

      axiosInstance
          .post(`/employee/admin/call-center-names/update`, body)
          .then((res) => {
            this.showPopup("success", res.data.message);
          })
          .catch((err) => {
            this.showPopup("error", err.response.data.message);
          });
    },
  },

  created() {
    this.getSettingData();
  },
};
</script>
